export default __webpack_public_path__ + "static/laptop-animated-d2ea5a8e045d5eabb2fe517ba3cdbea0.gif";